export default __webpack_public_path__ + "app/assets/images/patient/intakes/info-module/doctor_default.png";